import _objectSpread2 from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable no-underscore-dangle */

import * as React from 'react';
import { List, Map, Iterable } from 'immutable';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import createRef from 'create-react-ref/lib/createRef';
import { COLA_STATUS } from './cola/colaEnums';
import ChatWindow from './chatbot/ChatWindow.react';
import colaRequest from './cola';
import generateGuid from './helpers/generateGuid';

var DefaultChatBotIcon = function DefaultChatBotIcon(props) {
  return React.createElement("svg", props, React.createElement("style", null, ".chaticon0,.chaticon1,.chaticon2", "{", "fill-rule:evenodd;clip-rule:evenodd;fill:#fff", "}", ".chaticon1,.chaticon2", "{", "fill:#a6ce39", "}", ".chaticon2", "{", "fill:#006d38", "}"), React.createElement("title", null, "ChatBotIcon"), React.createElement("g", {
    id: "ChatBotIcon"
  }, React.createElement("path", {
    id: "Rectangle",
    className: "chaticon0",
    d: "M20 18h20c6.6 0 12 5.4 12 12s-5.4 12-12 12H20c-6.6 0-12-5.4-12-12s5.4-12 12-12z"
  }), React.createElement("path", {
    id: "Rectangle-Copy-31",
    className: "chaticon0",
    d: "M30 12c.6 0 1 .4 1 1v20c0 .6-.4 1-1 1s-1-.4-1-1V13c0-.6.4-1 1-1z"
  }), React.createElement("path", {
    id: "Combined-Shape-Copy-9",
    className: "chaticon1",
    d: "M31.8 38h-3.5c-2 0-3.6-1.3-4.2-3h12c-.7 1.7-2.4 3-4.3 3z"
  }), React.createElement("circle", {
    id: "Oval",
    className: "chaticon2",
    cx: "19",
    cy: "29",
    r: "4"
  }), React.createElement("circle", {
    id: "Oval-Copy-8",
    className: "chaticon0",
    cx: "30",
    cy: "11",
    r: "4"
  }), React.createElement("path", {
    className: "chaticon0",
    d: "M18 41h8l-8 8z"
  }), React.createElement("circle", {
    id: "Oval-Copy-7",
    className: "chaticon2",
    cx: "41",
    cy: "29",
    r: "4"
  })));
};

DefaultChatBotIcon.defaultProps = {
  id: "ChatBotIcon_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};

var DefaultCloseIcon = function DefaultCloseIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.588 1.604L7.256 5.936l4.332 4.333-1.32 1.32-4.332-4.333-4.332 4.332-1.272-1.272 4.333-4.332L.332 1.652l1.32-1.32 4.332 4.333L10.316.332z"
  }));
};

DefaultCloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};

var DefaultMessageIcon = function DefaultMessageIcon(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    fill: "#FFF",
    cx: "17",
    cy: "17",
    r: "17"
  }), React.createElement("path", {
    d: "M24 19.402v-4.804C24 12.616 22.364 11 20.357 11h-.873v2.154c0 2.973-2.444 5.386-5.455 5.386h-2.16v.862c0 1.982 1.637 3.598 3.644 3.598h4.844C22.386 22.978 24 21.384 24 19.402",
    fill: "#A6CE39"
  }), React.createElement("path", {
    d: "M17.348 13.017V11h-2.04c-1.894 0-3.438 1.528-3.438 3.402v2.017h2.038c1.895 0 3.44-1.528 3.44-3.402M7.462 12.548H6v1.455c0 1.33 1.092 2.416 2.45 2.416h1.463v-1.454c0-1.331-1.091-2.417-2.45-2.417",
    fill: "#006D38"
  })));
};

DefaultMessageIcon.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg"
};

var AgentMessageIcon = function AgentMessageIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "#006D38",
    fillRule: "evenodd",
    d: "M4.25 7.71c1.3-.3 4-.9 5.1-2.3 0 0 3 1.3 4 3.4.1.6 0 1.3 0 1.9-.7 4.4-2.9 5.3-4.7 5.3-1.8 0-4-1-4.6-5.3-.1-1 0-2.1.2-3m.4 7.6c1.3 1.6 2.9 1.9 4.1 1.9s2.8-.3 4.1-1.9c2.1.9 4.6.1 4.6.1-3-2.8-1.2-5.5-1.8-10.1-.6-4.6-5.1-5.3-6.9-5.3-1.9 0-6.3.7-7 5.3-.6 4.6 1.2 7.3-1.8 10.1.1 0 2.6.8 4.7-.1"
  }), React.createElement("path", {
    fill: "#A6CE39",
    fillRule: "evenodd",
    d: "M11.49 18.56c-1.5 1.5-4 1.5-5.5 0-.3-.3-.7-.3-.9 0s-.2.6 0 .9c1 1 2.2 1.5 3.6 1.5s2.7-.6 3.6-1.6c.3-.2.3-.6 0-.8s-.6-.3-.8 0"
  }));
};

AgentMessageIcon.defaultProps = {
  width: "34",
  height: "34",
  viewBox: "0 -4 17 27",
  xmlns: "http://www.w3.org/2000/svg"
};

var DefaultSubmitIcon = function DefaultSubmitIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M0 18l20-9L0 0v7l14.286 2L0 11z",
    fill: "#B0B0B0",
    fillRule: "nonzero"
  }));
};

DefaultSubmitIcon.defaultProps = {
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  xmlns: "http://www.w3.org/2000/svg"
};

var DefaultTypingIcon = function DefaultTypingIcon(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    fill: "#E6E6E6",
    width: "58",
    height: "34",
    rx: "17"
  }), React.createElement("circle", {
    fill: "#116C3A",
    cx: "16",
    cy: "17",
    r: "4"
  }), React.createElement("circle", {
    fill: "#116C3A",
    opacity: ".388",
    cx: "41",
    cy: "17",
    r: "4"
  }), React.createElement("circle", {
    fill: "#116C3A",
    opacity: ".591",
    cx: "29",
    cy: "17",
    r: "4"
  })));
};

DefaultTypingIcon.defaultProps = {
  viewBox: "0 0 58 34",
  xmlns: "http://www.w3.org/2000/svg"
};
import autoStart from './autostart/autostart';
import { CHATBOT_SCENARIOS, CHATBOT_AUTOSTART_DONE } from './autostart/scenarios/constants.js';
import { AlfavoxChat } from './alfavox';
import * as ALFA from './alfavox/constants';
import showdown from 'showdown/dist/showdown.js';
dayjs.extend(isBetween);
var MOBILE_WIDTH = 767;
var SCROLL_OFFSET = 300;
var TOOLTIP_TIMEOUT = 10000;
var FIRST_MESSAGE_TIMEOUT = 2000;
var FOLLOWUP_TIMEOUT = 3000;
var SECOND = 1000;
var CHATBOT_GUID = 'chatbot_guid';

var FinanceChat = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FinanceChat, _React$PureComponent);

  function FinanceChat(props) {
    var _this;

    _classCallCheck(this, FinanceChat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FinanceChat).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      typing: false,
      inputFieldEmpty: true,
      showToggleButton: false,
      showTooltip: false,
      firstMessageSentToZopim: false,
      isChatOpen: _this.props.mobileAppMode,
      lastQuestion: '',
      inputValue: '',
      conversationData: new List([]),
      // eslint-disable-line flowtype-errors/show-errors
      latestRawData: {},
      reset: false,
      clientId: null,
      adTimeout: _this.props.marketingBannerTimeout,
      adDisplayed: false,
      alfavoxChat: null,
      chatMode: ALFA.CHAT_MODE_BOT,
      feedbackSent: false,
      forceWelcome: false,
      isMobile: typeof window !== 'undefined' ? window.innerWidth <= MOBILE_WIDTH : false,
      talkToAgentConfirmation: false
    });

    _defineProperty(_assertThisInitialized(_this), "botSocket", void 0);

    _defineProperty(_assertThisInitialized(_this), "messagesEndRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "isMobile", false);

    _defineProperty(_assertThisInitialized(_this), "guid", null);

    _defineProperty(_assertThisInitialized(_this), "deleteChatHistory", function () {
      return _this.setState({
        conversationData: new List(),
        latestRawData: {}
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateWindowDimensions", function () {
      var isMobile = window.innerWidth <= MOBILE_WIDTH;

      if (document.body && document.documentElement) {
        if (window.innerWidth > MOBILE_WIDTH || window.pageYOffset > SCROLL_OFFSET || document.body.scrollHeight - document.documentElement.clientHeight < SCROLL_OFFSET) {
          _this.setState({
            showToggleButton: true,
            isMobile: isMobile
          });
        } else {
          _this.setState({
            showToggleButton: false,
            isMobile: isMobile
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "startZopimChat", function () {
      var liveChatSay = _this.props.liveChatSay;

      var chatLog = _this._createChatLog();

      if (_this.props.showLogs) {
        console.log('Starting Zopim chat with log:', _this._createChatLog());
      }

      liveChatSay(chatLog);

      _this.setState({
        firstMessageSentToZopim: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFollowupQuestion", function () {
      var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this$props = _this.props,
          msg = _this$props.msg,
          marketingFeatures = _this$props.marketingFeatures,
          marketingBannerTimeout = _this$props.marketingBannerTimeout;
      var _this$state = _this.state,
          adDisplayed = _this$state.adDisplayed,
          adTimeout = _this$state.adTimeout;
      setTimeout(function () {
        // $FlowFixMe
        _this.updateChatHistory({
          message: msg('chatBot.chatEnd.message'),
          type: 'answer',
          timestamp: Date.now(),
          prompts: [{
            displayText: msg('chatBot.chatEnd.continue')
          }, {
            displayText: msg('chatBot.chatEnd.end')
          }],
          metadata: meta,
          customClass: 'chatbot__followupMsg'
        });

        if (marketingFeatures && !adDisplayed && adTimeout === marketingBannerTimeout) _this.startAdTimeout();

        _this.setState({
          adTimeout: marketingBannerTimeout
        });
      }, FOLLOWUP_TIMEOUT);
    });

    _defineProperty(_assertThisInitialized(_this), "renderLiveChatAnswer", function (data) {
      var msg = _this.props.msg;
      data.forEach(function (message) {
        var answer = {
          message: message.Text,
          type: 'answer',
          icon: 'agent',
          id: message.id,
          timestamp: Date.now(),
          prompts: []
        };

        if (_this.props.showLogs) {
          console.log('Received live chat answer:', message);
        }

        _this.updateChatHistory(answer);

        if (message.Text !== msg('chatBot.disconnectLiveChat')) {
          _this.setState({
            typing: false
          });
        } else {
          _this.setState({
            chatMode: ALFA.CHAT_MODE_BOT,
            typing: false
          });

          _this.renderFollowupQuestion();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitFeedback", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rating) {
        var msg;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                msg = _this.props.msg;

                if (_this.props.showLogs) {
                  console.log("Submitting feedback: ".concat(rating));
                }

                _this.systemLog("feedback ".concat(rating));

                _this.setState({
                  feedbackSent: true
                });

                if (rating === 1) _this.updateChatHistory({
                  message: msg('chatBot.feedback.positiveResponse'),
                  type: 'answer',
                  timestamp: Date.now(),
                  prompts: [{
                    displayText: msg('chatBot.chatEnd.restart')
                  }]
                });
                if (rating === 0) _this.updateChatHistory({
                  message: msg('chatBot.feedback.negativeResponse'),
                  type: 'answer',
                  timestamp: Date.now(),
                  prompts: [{
                    displayText: msg('chatBot.chatEnd.restart')
                  }]
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleChatWindow", function () {
      var _this$state2 = _this.state,
          isChatOpen = _this$state2.isChatOpen,
          forceWelcome = _this$state2.forceWelcome;

      if (isChatOpen) {
        _this.closeChatWindow();
      } else {
        _this.hideTooltip();

        if (forceWelcome) {
          _this._welcomeMessage();

          _this.setState({
            forceWelcome: false
          });
        }

        _this.openChatWindow();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submitQuestion", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
        var _this$state3, conversationData, adDisplayed, alfavoxChat, chatMode, feedbackSent, isMobile, _this$props2, msg, goToLogin, clientId, marketingFeatures, chatbotFeedback, lastMessage, metadata, oldVersionMetadataCondition, newVersionMetadataCondition, chatMsg, lastAnswer;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$state3 = _this.state, conversationData = _this$state3.conversationData, adDisplayed = _this$state3.adDisplayed, alfavoxChat = _this$state3.alfavoxChat, chatMode = _this$state3.chatMode, feedbackSent = _this$state3.feedbackSent, isMobile = _this$state3.isMobile;
                _this$props2 = _this.props, msg = _this$props2.msg, goToLogin = _this$props2.goToLogin, clientId = _this$props2.clientId, marketingFeatures = _this$props2.marketingFeatures, chatbotFeedback = _this$props2.chatbotFeedback;

                if (!item.toLogin) {
                  _context2.next = 7;
                  break;
                }

                if (isMobile) {
                  _this.closeChatWindow();
                }

                if (_this.props.showLogs) {
                  console.log('User redirected to login');
                }

                goToLogin();
                return _context2.abrupt("return");

              case 7:
                if (!(item.displayText === '')) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                if (!(item.displayText === msg('chatBot.talkWithAgent'))) {
                  _context2.next = 13;
                  break;
                }

                if (_this.props.showLogs) {
                  console.log('User requested to talk with an agent');
                }

                _this.talkToAgent();

                return _context2.abrupt("return");

              case 13:
                _this.setState({
                  talkToAgentConfirmation: false
                });

                _this.updateInput('');

                if (!(chatMode === ALFA.CHAT_MODE_BOT)) {
                  _context2.next = 46;
                  break;
                }

                if (!(item.displayText === msg('chatBot.chatEnd.restart') || item.displayText === msg('chatBot.chatStart.continue'))) {
                  _context2.next = 20;
                  break;
                }

                if (_this.props.showLogs) {
                  console.log('User restarted or continued the chat');
                }

                _this._chatBotMainMenu();

                return _context2.abrupt("return");

              case 20:
                lastMessage = conversationData.last();
                metadata = lastMessage ? lastMessage.get('metadata', null) : null;

                if (_this.props.showLogs) {
                  console.log('metadata: ', metadata, 'isArray:', Array.isArray(metadata));
                }

                oldVersionMetadataCondition = metadata && Array.isArray(metadata) && metadata.filter(function (e) {
                  return e.name === 'anotherquestion';
                }).length > 0;
                newVersionMetadataCondition = !!metadata && !!metadata.anotherquestion;

                if (!(oldVersionMetadataCondition || newVersionMetadataCondition)) {
                  _context2.next = 38;
                  break;
                }

                if (!(item.displayText === msg('chatBot.chatEnd.continue'))) {
                  _context2.next = 31;
                  break;
                }

                _this._chatBotMainMenu();

                return _context2.abrupt("return");

              case 31:
                if (!(item.displayText === msg('chatBot.chatEnd.end'))) {
                  _context2.next = 38;
                  break;
                }

                if (_this.props.showLogs) {
                  console.log('User chose to end the conversation');
                }

                _this.updateChatHistory({
                  message: msg('chatBot.chatEnd.end'),
                  qnaId: item.qnaId,
                  type: 'question',
                  timestamp: Date.now(),
                  prompts: []
                });

                _this.updateChatHistory({
                  message: msg('chatBot.chatEnd.endConversation'),
                  type: 'answer',
                  timestamp: Date.now(),
                  prompts: [{
                    displayText: msg('chatBot.chatEnd.restart')
                  }]
                });

                if (chatbotFeedback && !feedbackSent) _this.askFeedback();
                if (marketingFeatures && !adDisplayed) _this.startAdTimeout(true);
                return _context2.abrupt("return");

              case 38:
                _this.updateLastQuestion(item.displayText);

                chatMsg = {
                  type: 'message',
                  text: item.displayText,
                  user: _this.guid,
                  channel: 'websocket',
                  cookies: document.cookie,
                  timestamp: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  client: clientId ? {
                    id: clientId
                  } : null
                }; // $FlowFixMe

                lastAnswer = conversationData.findLast && conversationData.findLast(function (msgItem) {
                  return msgItem.get('type') === 'answer';
                });

                if (lastAnswer !== undefined) {
                  chatMsg.lastAnswer = {
                    previousQnAId: lastAnswer.get('id'),
                    previousUserQuery: lastAnswer.get('message')
                  };
                }

                if (_this.props.showLogs) {
                  console.log('Sending chat message', chatMsg.text);
                  console.table(chatMsg);
                }

                _this.botSocket.send(JSON.stringify(chatMsg));

                _context2.next = 49;
                break;

              case 46:
                if (alfavoxChat) {
                  alfavoxChat.sendMessage(item.displayText);

                  _this.updateChatHistory({
                    message: item.displayText,
                    type: 'question',
                    timestamp: Date.now(),
                    prompts: []
                  });
                }

                if (_this.props.showLogs) {
                  console.log('Message sent via Alfavox chat:', item.displayText);
                }

                return _context2.abrupt("return");

              case 49:
                _this.setState({
                  typing: true
                });

                _this.updateChatHistory({
                  message: item.displayText,
                  qnaId: item.qnaId,
                  type: 'question',
                  timestamp: Date.now(),
                  prompts: []
                });

              case 51:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleEditLast", function (e) {
      var lastQuestion = _this.state.lastQuestion;

      if (e.key === 'ArrowUp') {
        _this.updateInput(lastQuestion);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e) {
      var marketingBannerTimeout = _this.props.marketingBannerTimeout;

      _this.updateInput(e.target.value);

      if (e.target.value) {
        _this.setState({
          inputFieldEmpty: false,
          adTimeout: marketingBannerTimeout
        });
      } else {
        _this.setState({
          inputFieldEmpty: true,
          adTimeout: marketingBannerTimeout
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getLastChatQuestion", function () {
      // $FlowFixMe
      var lastChatQuestion = _this.state.conversationData.findLast(function (msgItem) {
        return msgItem.get('type') === 'question';
      }); // $FlowFixMe


      return lastChatQuestion ? lastChatQuestion.toJS() : null;
    });

    _defineProperty(_assertThisInitialized(_this), "systemLog", function (messageText) {
      var clientId = _this.props.clientId;
      var logMsg = {
        type: 'system-log',
        text: messageText,
        user: _this.guid,
        channel: 'websocket',
        cookies: document.cookie,
        timestamp: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        client: clientId ? {
          id: clientId
        } : null
      };

      _this.botSocket.send(JSON.stringify(logMsg));
    });

    _defineProperty(_assertThisInitialized(_this), "isLiveAgentWorkingHours", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(campaign) {
        var _this$props3, workingHoursRequest, workingHours, currentTime, useWorkingHours, useWorkingHoursFrom, useWorkingHoursTo, startTime, endTime;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = _this.props, workingHoursRequest = _this$props3.alfavoxRequests.workingHoursRequest, workingHours = _this$props3.workingHours;
                currentTime = dayjs();

                if (!workingHoursRequest) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 5;
                return workingHoursRequest(campaign);

              case 5:
                useWorkingHours = _context3.sent;
                useWorkingHoursFrom = dayjs().set('hour', useWorkingHours.from.hours).set('minute', useWorkingHours.from.minutes);
                useWorkingHoursTo = dayjs().set('hour', useWorkingHours.to.hours).set('minute', useWorkingHours.to.minutes);

                if (!(useWorkingHours.status === 'ALFAVOX_ERROR')) {
                  _context3.next = 11;
                  break;
                }

                _this.systemLog('ERROR: failed to get live agent working hours');

                return _context3.abrupt("return", null);

              case 11:
                return _context3.abrupt("return", currentTime.isBetween(useWorkingHoursFrom, useWorkingHoursTo));

              case 12:
                startTime = dayjs().day() > 5 ? dayjs().set('hour', workingHours.weekendStart).set('minute', 0) : dayjs().set('hour', workingHours.weekdayStart).set('minute', 0);
                endTime = dayjs().day() > 5 ? dayjs().set('hour', workingHours.weekendEnd).set('minute', 0) : dayjs().set('hour', workingHours.weekdayEnd).set('minute', 0);
                return _context3.abrupt("return", currentTime.isBetween(startTime, endTime));

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "isLiveAgentAvailable", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(campaign) {
        var availableAgentCount, availableAgents;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                availableAgentCount = _this.props.alfavoxRequests.availableAgentCount;

                if (!availableAgentCount) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 4;
                return availableAgentCount(campaign);

              case 4:
                availableAgents = _context4.sent;

                if (!(availableAgents.status === 'ALFAVOX_ERROR')) {
                  _context4.next = 8;
                  break;
                }

                _this.systemLog('ERROR: failed to get available live agent count');

                return _context4.abrupt("return", null);

              case 8:
                return _context4.abrupt("return", availableAgents.data > 0);

              case 9:
                return _context4.abrupt("return", true);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "talkToAgent", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this$props4, clientNr, zopimLoaded, openChat, msg, alfavoxEnabled, latestLoan, _this$state4, alfavoxChat, talkToAgentConfirmation, agreementType, isDeco, overdueDays, campaign, workingHours, isLiveAgentAvailable;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props4 = _this.props, clientNr = _this$props4.clientNr, zopimLoaded = _this$props4.zopimLoaded, openChat = _this$props4.openChat, msg = _this$props4.msg, alfavoxEnabled = _this$props4.alfavoxEnabled, latestLoan = _this$props4.latestLoan;
              _this$state4 = _this.state, alfavoxChat = _this$state4.alfavoxChat, talkToAgentConfirmation = _this$state4.talkToAgentConfirmation;
              agreementType = Iterable.isIterable(latestLoan) ? latestLoan.get('agreementType') : latestLoan.agreementType;
              isDeco = latestLoan && agreementType === 'DEBT_COLLECTION';
              overdueDays = Iterable.isIterable(latestLoan) ? latestLoan.get('overDueDays') : latestLoan.overDueDays;
              campaign = isDeco ? ALFA.CAMPAIGN_DECO : ALFA.CAMPAIGN_SALES;
              _context5.next = 8;
              return _this.isLiveAgentWorkingHours(campaign);

            case 8:
              workingHours = _context5.sent;
              _context5.next = 11;
              return _this.isLiveAgentAvailable(campaign);

            case 11:
              isLiveAgentAvailable = _context5.sent;

              if (!(workingHours === null || isLiveAgentAvailable === null)) {
                _context5.next = 15;
                break;
              }

              _this.updateChatHistory({
                message: msg('chatBot.errorConnectingLiveChat'),
                type: 'answer',
                prompts: [{
                  displayText: msg('chatBot.chatEnd.restart')
                }]
              });

              return _context5.abrupt("return");

            case 15:
              if (workingHours) {
                _context5.next = 19;
                break;
              }

              _this.updateChatHistory({
                message: msg('chatBot.outOfWorkTime'),
                type: 'answer',
                prompts: [{
                  displayText: msg('chatBot.chatEnd.restart')
                }]
              });

              _this.systemLog('talkToAgent out of working hours');

              return _context5.abrupt("return");

            case 19:
              if (isLiveAgentAvailable) {
                _context5.next = 22;
                break;
              }

              _this.updateChatHistory({
                message: msg('chatBot.liveAgentsNotAvailable'),
                type: 'answer',
                prompts: [{
                  displayText: msg('chatBot.chatEnd.restart')
                }]
              });

              return _context5.abrupt("return");

            case 22:
              if (alfavoxEnabled && alfavoxChat) {
                if (talkToAgentConfirmation) {
                  _this.setState({
                    talkToAgentConfirmation: false,
                    chatMode: ALFA.CHAT_MODE_REAL,
                    typing: true
                  });

                  alfavoxChat.startConversation(clientNr, isDeco || overdueDays > 0, msg('chatBot.disconnectLiveChat'));
                } else {
                  _this.setState({
                    talkToAgentConfirmation: true
                  });

                  _this.updateChatHistory({
                    message: msg('chatBot.confirmTalkToAgent'),
                    type: 'answer',
                    prompts: [{
                      displayText: msg('chatBot.talkWithAgent')
                    }, {
                      displayText: msg('chatBot.chatEnd.restart')
                    }]
                  });
                }
              } else {
                openChat(zopimLoaded);

                _this.closeChatWindow();

                _this.renderFollowupQuestion();
              }

              _this.systemLog('talkToAgent connected');

            case 24:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "scrollToBottom", function () {
      if (_this.messagesEndRef.current) _this.messagesEndRef.current.scrollIntoView(true);
    });

    _defineProperty(_assertThisInitialized(_this), "hideTooltip", function () {
      window.sessionStorage.setItem('tooltipShowed', true);

      _this.setState({
        showTooltip: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showTooltip", function () {
      if (!window.sessionStorage.getItem('tooltipShowed')) {
        _this.setState({
          showTooltip: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "autoStart", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _this$props5, autoStartSettings, clientId, webapiUrl, requestOverrideHeaders, minuteInactivity, _this$state5, isChatOpen, conversationData, doStart;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this$props5 = _this.props, autoStartSettings = _this$props5.autoStartSettings, clientId = _this$props5.clientId, webapiUrl = _this$props5.webapiUrl, requestOverrideHeaders = _this$props5.requestOverrideHeaders, minuteInactivity = _this$props5.minuteInactivity;
              _this$state5 = _this.state, isChatOpen = _this$state5.isChatOpen, conversationData = _this$state5.conversationData;

              if (!(clientId && !isChatOpen && autoStartSettings && conversationData.isEmpty())) {
                _context6.next = 8;
                break;
              }

              if (!autoStartSettings) {
                _context6.next = 8;
                break;
              }

              _context6.next = 6;
              return autoStart(autoStartSettings, webapiUrl, requestOverrideHeaders, {
                minuteInactivity: minuteInactivity
              });

            case 6:
              doStart = _context6.sent;

              if (doStart) {
                _this.hideTooltip();

                if (!_this.botSocket) {
                  _this.connectToBot(doStart);
                } else {
                  _this._welcomeMessage(doStart);
                }

                _this.setState({
                  isChatOpen: true
                });
              }

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));

    var _alfavoxEnabled = props.alfavoxEnabled,
        alfavoxRequests = props.alfavoxRequests;

    if (_alfavoxEnabled) {
      var alfavoxChat = new AlfavoxChat(alfavoxRequests, {
        liveMessages: _this.renderLiveChatAnswer
      });

      if (_this.props.showLogs) {
        console.log('AlfavoxChat initialized:', alfavoxChat);
      }

      _this.state = _objectSpread2({}, _this.state, {
        alfavoxChat: alfavoxChat
      });
    }

    return _this;
  }

  _createClass(FinanceChat, [{
    key: "openChatWindow",
    value: function openChatWindow() {
      this.setState({
        isChatOpen: true
      });
    }
  }, {
    key: "closeChatWindow",
    value: function closeChatWindow() {
      this.setState({
        isChatOpen: false
      });
    }
  }, {
    key: "updateLastQuestion",
    value: function updateLastQuestion(lastQuestion) {
      this.setState({
        lastQuestion: lastQuestion
      });
    }
  }, {
    key: "updateInput",
    value: function updateInput(inputValue) {
      this.setState({
        inputValue: inputValue
      });
    }
  }, {
    key: "updateChatHistory",
    value: function updateChatHistory(newMessage) {
      var _this2 = this;

      var _this$props6 = this.props,
          storeHistoryInSessionStorage = _this$props6.storeHistoryInSessionStorage,
          showLogs = _this$props6.showLogs; // $FlowFixMe

      this.props.onMessage(newMessage);

      if (showLogs) {
        console.log("attempting to update chat history with message: ".concat(newMessage.message));
      }

      this.setState(function (prevState) {
        return {
          // $FlowFixMe
          conversationData: prevState.conversationData.push(new Map(newMessage))
        };
      }, function () {
        var stringifiedChatHistory = JSON.stringify(_this2.state.conversationData.toJS());

        if (storeHistoryInSessionStorage) {
          sessionStorage.setItem('chatHistory', stringifiedChatHistory);
        }
      });
    }
  }, {
    key: "restoreChatHistoryFromSession",
    value: function restoreChatHistoryFromSession() {
      var restoredSession = sessionStorage.getItem('chatHistory');
      if (!restoredSession) return;
      var parsedSession = JSON.parse(restoredSession); // $FlowFixMe

      var conversationData = new List(parsedSession.map(function (message) {
        return new Map(message);
      }));
      this.setState({
        conversationData: conversationData
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var zopimLoaded = this.props.zopimLoaded;
      var _this$state6 = this.state,
          firstMessageSentToZopim = _this$state6.firstMessageSentToZopim,
          reset = _this$state6.reset,
          isChatOpen = _this$state6.isChatOpen;

      if (reset) {
        this.deleteChatHistory();

        if (isChatOpen) {
          this._welcomeMessage(null, true);
        } else {
          this.state.forceWelcome = true;
        }

        this.state.reset = false;
      }

      this.scrollToBottom();
      if (zopimLoaded && !firstMessageSentToZopim) this.startZopimChat();

      if (!this.guid) {
        var sessionGuid = window.sessionStorage.getItem(CHATBOT_GUID) || generateGuid();
        window.sessionStorage.setItem(CHATBOT_GUID, sessionGuid);
        this.guid = sessionGuid;
      }

      this.autoStart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.botSocket) {
        this.botSocket.close();

        if (this.props.showLogs) {
          console.log('Chatbot websocket closed');
        }
      }

      window.removeEventListener('resize', this.updateWindowDimensions);
      window.removeEventListener('scroll', this.updateWindowDimensions);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.restoreChatHistoryFromSession();
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
      window.addEventListener('scroll', this.updateWindowDimensions);
      setTimeout(function () {
        _this3.showTooltip();
      }, TOOLTIP_TIMEOUT);
    }
  }, {
    key: "_chatBotMainMenu",
    value: function _chatBotMainMenu() {
      var clientId = this.props.clientId;

      if (this.props.showLogs) {
        console.log('Sending initial message via WebSocket');
      }

      this.botSocket.send(JSON.stringify({
        type: 'message',
        channel: 'websocket',
        user: this.guid,
        user_profile: null,
        text: this.props.startConversationText,
        cookies: document.cookie,
        client: clientId ? {
          id: clientId
        } : null,
        timestamp: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      }));
    }
  }, {
    key: "_createChatLog",
    value: function _createChatLog() {
      var msg = this.props.msg;
      var conversationData = this.state.conversationData;
      var messages = msg('chatBot.chatLogToZopim.chatBeforeTitle');
      conversationData.map(function (message) {
        // eslint-disable-line array-callback-return
        if (message.get('type') === 'answer') {
          messages += "\n".concat(msg('chatBot.chatLogToZopim.chatbot'), ": ").concat(message.get('message'));
        } else {
          messages += "\n".concat(msg('chatBot.chatLogToZopim.user'), ": ").concat(message.get('message'));
        }
      });
      return messages;
    }
  }, {
    key: "_welcomeMessage",
    value: function _welcomeMessage() {
      var _this4 = this;

      var initialMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var conversationData = this.state.conversationData;

      if (this.guid && this.botSocket && (conversationData.isEmpty() || force)) {
        var _this$props7 = this.props,
            msg = _this$props7.msg,
            clientId = _this$props7.clientId;

        if (this.props.showLogs) {
          console.log('Sending welcome message via WebSocket');
        }

        if (!initialMessage) {
          this.updateChatHistory({
            message: msg('chatBot.chatStart.message'),
            type: 'answer',
            customClass: 'chatbot__startMsg',
            prompts: []
          });
          setTimeout(function () {
            _this4.updateChatHistory({
              message: msg('chatBot.chatStart.rules'),
              type: 'answer',
              customClass: 'chatbot__rulesMsg',
              prompts: [{
                displayText: msg('chatBot.chatStart.continue')
              }]
            });

            _this4.setState({
              typing: false
            });
          }, FIRST_MESSAGE_TIMEOUT);
        } else {
          var chatMsg = {
            type: 'message',
            text: initialMessage,
            user: this.guid,
            channel: 'websocket',
            cookies: document.cookie,
            timestamp: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            client: clientId ? {
              id: clientId
            } : null
          };

          if (this.props.showLogs) {
            console.log('Sending custom welcome message:', chatMsg);
          }

          this.botSocket.send(JSON.stringify(chatMsg));
        }
      }
    }
  }, {
    key: "showAdvertisement",
    value: function showAdvertisement() {
      var _this$props8 = this.props,
          locale = _this$props8.locale,
          clientId = _this$props8.clientId;
      var isChatOpen = this.state.isChatOpen;
      var bannerID = Math.round(Math.random() + 1);
      this.botSocket.send(JSON.stringify({
        type: 'message',
        channel: 'websocket',
        user: this.guid,
        user_profile: null,
        text: "[advertisement.banner.".concat(bannerID, ".").concat(locale, "]"),
        cookies: document.cookie,
        client: clientId ? {
          id: clientId
        } : null,
        timestamp: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      }));

      if (!isChatOpen) {
        this.setState({
          showTooltip: true,
          adDisplayed: true
        });
      } else {
        this.setState({
          adDisplayed: true
        });
      }
    }
  }, {
    key: "startAdTimeout",
    value: function startAdTimeout() {
      var _this5 = this;

      var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (now) {
        this.showAdvertisement();
      } else {
        var adInterval = setInterval(function () {
          if (_this5.state.adDisplayed) clearInterval(adInterval);

          if (_this5.state.adTimeout === 0) {
            _this5.showAdvertisement();

            clearInterval(adInterval);
          }

          _this5.setState({
            adTimeout: _this5.state.adTimeout - SECOND
          });
        }, 1000);
      }
    }
  }, {
    key: "askFeedback",
    value: function askFeedback() {
      var msg = this.props.msg;

      if (this.props.showLogs) {
        console.log('Asking for feedback');
      }

      this.updateChatHistory({
        message: msg('chatBot.feedback.ask'),
        type: 'answer',
        timestamp: Date.now(),
        prompts: [{
          displayText: msg('chatBot.chatEnd.restart')
        }],
        feedback: true
      });
    }
  }, {
    key: "connectToBot",
    value: function connectToBot() {
      var _this6 = this;

      var initialMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this$props9 = this.props,
          nodeHost = _this$props9.nodeHost,
          webapiUrl = _this$props9.webapiUrl,
          stopRequests = _this$props9.stopRequests,
          marketingBannerTimeout = _this$props9.marketingBannerTimeout,
          enableTalkToAgent = _this$props9.enableTalkToAgent;
      var markdownConverter = new showdown.Converter();

      if (!this.botSocket) {
        var msg = this.props.msg;
        var conversationData = this.state.conversationData;

        if (this.props.showLogs) {
          console.log("Connecting to WebSocket on ".concat(nodeHost, "/chatbot"));
        }

        this.botSocket = new WebSocket("".concat(nodeHost, "/chatbot"));
        this.botSocket.addEventListener('open', function ()
        /* event: Event */
        {
          if (_this6.props.showLogs) {
            console.log('SOCKET OPEN!');
          }

          if (conversationData.size <= 0) {
            _this6.setState({
              typing: true
            });

            _this6._welcomeMessage(initialMessage);
          }
        });
        this.botSocket.addEventListener('close', function ()
        /* event: Event */
        {
          if (_this6.props.showLogs) {
            console.log('SOCKET CLOSED!');
          }
        }); // $FlowFixMe

        this.botSocket.addEventListener('message', function (event) {
          if (_this6.props.showLogs) {
            console.log('SOCKET MESSAGE EVENT:');
            console.log({
              event: event
            });
          }

          var data = JSON.parse(typeof event.data === 'string' ? event.data : '');

          if (data.type !== 'trace') {
            // TODO temporary workaround to ignore anything except qna answer from bot
            if (_this6.props.showLogs) {
              console.log('Received a response: ');
              console.table(data);
              console.log('data', _objectSpread2({}, data));
              console.log('- - - - - - - - - - - - - - - - - - -');
            }

            _this6.setState({
              latestRawData: data
            }, function () {
              if (data[0] && data[0].answer) {
                if (_this6.props.showLogs) {
                  console.log("CHOSEN ANSWER: ".concat(markdownConverter.makeHtml(data[0].answer)));
                }

                var answer = {
                  message: markdownConverter.makeHtml(data[0].answer),
                  type: 'answer',
                  id: data[0].id,
                  timestamp: Date.now(),
                  prompts: []
                };

                if (data[0].context) {
                  answer.prompts = data[0].context.prompts;

                  if (_this6.props.showLogs) {
                    console.log('Data have context, OLD version used');
                    console.log(data[0].context);
                  }
                } else if (data[0].dialog) {
                  answer.prompts = data[0].dialog.prompts;

                  if (_this6.props.showLogs) {
                    console.log('Data have dialog, NEW version used');
                    console.log(data[0].dialog);
                  }
                }

                if (data[0].metadata && data[0].metadata.length > 0 || data[0].metadata && Object.keys(data[0].metadata).length > 0) {
                  var lastQuestion = _this6.state.lastQuestion;
                  var meta = data[0].metadata;
                  var isMetaArray = Array.isArray(meta);

                  if (_this6.props.showLogs) {
                    var version = isMetaArray ? 'OLD' : 'NEW';
                    console.log("MetaData point to ".concat(version, " version"));
                  }

                  var talkToAgent = isMetaArray ? meta.filter(function (e) {
                    return e.name === 'talktoagent' && e.value === 'true';
                  }).length > 0 : meta.talktoagent;
                  var anotherQuestion = isMetaArray ? meta.filter(function (e) {
                    return e.name === 'anotherquestion' && e.value === 'true';
                  }).length > 0 : meta.anotherquestion;
                  var ignoreDebt = isMetaArray ? meta.filter(function (e) {
                    return e.name === 'ignoredebt' && e.value === 'true';
                  }).length > 0 : meta.ignoredebt;
                  var cola = isMetaArray ? meta.filter(function (e) {
                    return e.name === 'cola' && e.value === 'true';
                  }).length > 0 : meta.cola;

                  if (talkToAgent) {
                    _this6.talkToAgent();
                  } else if (cola) {
                    var latestLoan = _this6.props.latestLoan;

                    if (!stopRequests) {
                      // $FlowFixMe
                      var agreementType = Iterable.isIterable(latestLoan) ? latestLoan.get('agreementType') : latestLoan.agreementType;

                      if (!ignoreDebt && latestLoan && agreementType === 'DEBT_COLLECTION') {
                        answer.message = msg('chatBot.debtCollection');

                        _this6.updateChatHistory(answer);

                        _this6.renderFollowupQuestion(meta);
                      } else {
                        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                          var requestOverrideHeaders, _ref8, status, processedMessage;

                          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                            while (1) {
                              switch (_context7.prev = _context7.next) {
                                case 0:
                                  requestOverrideHeaders = _this6.props.requestOverrideHeaders;
                                  _context7.next = 3;
                                  return colaRequest(data[0], msg, webapiUrl, requestOverrideHeaders);

                                case 3:
                                  _ref8 = _context7.sent;
                                  status = _ref8.status;
                                  processedMessage = _ref8.processedMessage;

                                  if (status === COLA_STATUS.UNAUTHORISED) {
                                    answer.message = msg('chatBot.notLoggedIn');
                                    answer.prompts = [{
                                      displayText: msg('chatBot.goToLoginPage'),
                                      toLogin: true
                                    }, {
                                      displayText: msg('chatBot.chatEnd.restart')
                                    }, {
                                      displayText: lastQuestion
                                    }];
                                  } else {
                                    answer.message = processedMessage;
                                  }

                                  _this6.updateChatHistory(answer);

                                  if (status !== COLA_STATUS.UNAUTHORISED && anotherQuestion) _this6.renderFollowupQuestion(meta);

                                case 9:
                                case "end":
                                  return _context7.stop();
                              }
                            }
                          }, _callee7);
                        }))();
                      }
                    } else {
                      answer.message = msg('chatBot.notLoggedIn');
                      answer.prompts = [{
                        displayText: msg('chatBot.goToLoginPage'),
                        toLogin: true
                      }, {
                        displayText: msg('chatBot.chatEnd.restart')
                      }, {
                        displayText: lastQuestion
                      }];

                      _this6.updateChatHistory(answer);
                    }
                  } else {
                    _this6.updateChatHistory(answer);

                    if (anotherQuestion) _this6.renderFollowupQuestion(meta);
                  }
                } else {
                  _this6.updateChatHistory(answer);
                }
              } else {
                _this6.updateChatHistory({
                  message: msg('chatBot.noQuestionFound'),
                  type: 'answer',
                  prompts: enableTalkToAgent ? [{
                    displayText: msg('chatBot.talkWithAgent')
                  }, {
                    displayText: msg('chatBot.chatEnd.restart')
                  }] : [{
                    displayText: msg('chatBot.chatEnd.restart')
                  }],
                  timestamp: Date.now(),
                  customClass: 'chatbot__notFoundMsg'
                });
              }

              _this6.setState({
                typing: false,
                adTimeout: marketingBannerTimeout
              });
            });
          }
        });
      }
    }
  }, {
    key: "renderChat",
    value: function renderChat() {
      var _this$state7 = this.state,
          typing = _this$state7.typing,
          inputFieldEmpty = _this$state7.inputFieldEmpty,
          inputValue = _this$state7.inputValue,
          conversationData = _this$state7.conversationData,
          chatMode = _this$state7.chatMode;
      var _this$props10 = this.props,
          msg = _this$props10.msg,
          HeaderIcon = _this$props10.HeaderIcon,
          MessageIcon = _this$props10.MessageIcon,
          AgentIcon = _this$props10.AgentIcon,
          SubmitIcon = _this$props10.SubmitIcon,
          TypingIcon = _this$props10.TypingIcon,
          enableTalkToAgent = _this$props10.enableTalkToAgent,
          mobileAppMode = _this$props10.mobileAppMode;
      this.connectToBot();
      return (// $FlowFixMe
        React.createElement(ChatWindow, {
          msg: msg,
          conversationData: conversationData,
          submitQuestion: this.submitQuestion,
          submitFeedback: this.submitFeedback,
          typing: typing,
          inputFieldEmpty: inputFieldEmpty,
          enableTalkToAgent: enableTalkToAgent,
          talkToAgent: this.talkToAgent,
          inputValue: inputValue,
          handleInputChange: this.handleInputChange,
          handleEditLast: this.handleEditLast,
          messagesEndRef: this.messagesEndRef,
          HeaderIcon: HeaderIcon,
          MessageIcon: MessageIcon,
          AgentIcon: AgentIcon,
          SubmitIcon: SubmitIcon,
          TypingIcon: TypingIcon,
          mobileAppMode: mobileAppMode,
          chatModeBot: chatMode === ALFA.CHAT_MODE_BOT
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          msg = _this$props11.msg,
          OpenIcon = _this$props11.OpenIcon,
          CloseIcon = _this$props11.CloseIcon;
      var _this$state8 = this.state,
          showToggleButton = _this$state8.showToggleButton,
          showTooltip = _this$state8.showTooltip,
          isChatOpen = _this$state8.isChatOpen,
          adDisplayed = _this$state8.adDisplayed,
          isMobile = _this$state8.isMobile;
      return React.createElement("div", null, isChatOpen && this.renderChat(), React.createElement("div", {
        className: "chatbot__chatToggleContainer ".concat(isChatOpen ? 'chatbot__containerOpen' : '', " ").concat(showToggleButton ? 'chatbot__visible' : '')
      }, showTooltip && React.createElement("div", {
        className: "chatbot__tooltip",
        style: {
          display: adDisplayed && isMobile || !isMobile ? 'block' : 'none'
        }
      }, !adDisplayed ? msg('chatBot.tooltip.askBot') : msg('chatBot.tooltip.newMessage'), React.createElement(CloseIcon, {
        onClick: this.hideTooltip,
        className: "chatbot__tooltipClose"
      })), React.createElement("div", {
        className: "chatbot__chatToggle ".concat(isChatOpen ? 'chatbot__toggleOpen' : ''),
        onClick: this.toggleChatWindow
      }, isChatOpen ? React.createElement(CloseIcon, null) : React.createElement(OpenIcon, null))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.clientId !== prevState.clientId) {
        if (nextProps.showLogs) {
          console.log('clientId changed:', nextProps.clientId);
        } // If clientId changes from something to null, wipe history


        if (prevState.clientId && !nextProps.clientId) {
          sessionStorage.removeItem('chatHistory');
          sessionStorage.removeItem(CHATBOT_AUTOSTART_DONE);
          sessionStorage.removeItem(CHATBOT_SCENARIOS);
          return {
            clientId: nextProps.clientId,
            reset: true
          };
        }

        return {
          clientId: nextProps.clientId
        };
      }

      return null;
    }
  }]);

  return FinanceChat;
}(React.PureComponent);

_defineProperty(FinanceChat, "defaultProps", {
  webapiUrl: '',
  zopimLoaded: false,
  latestLoan: {},
  stopRequests: false,
  startConversationText: '[start.conversation]',
  enableTalkToAgent: true,
  onMessage: function onMessage() {},
  liveChatSay: function liveChatSay() {},
  goToLogin: function goToLogin() {},
  openChat: function openChat() {},
  msg: function msg() {
    return 'Translation function not passed through props';
  },
  requestOverrideHeaders: {},
  clientNr: null,
  HeaderIcon: DefaultChatBotIcon,
  OpenIcon: DefaultChatBotIcon,
  CloseIcon: DefaultCloseIcon,
  MessageIcon: DefaultMessageIcon,
  AgentIcon: AgentMessageIcon,
  SubmitIcon: DefaultSubmitIcon,
  TypingIcon: DefaultTypingIcon,
  workingHours: {
    weekdayStart: 8,
    weekdayEnd: 21,
    weekendStart: 9,
    weekendEnd: 19
  },
  autoStartSettings: null,
  minuteInactivity: false,
  marketingFeatures: false,
  marketingBannerTimeout: 7000,
  chatbotFeedback: false,
  locale: '',
  storeHistoryInSessionStorage: false,
  mobileAppMode: false,
  alfavoxEnabled: false,
  alfavoxRequests: {
    workingHoursRequest: null,
    agentsAvailable: null,
    getMessages: null,
    sendMessage: null,
    close: null,
    getConversationStatus: null,
    initialize: null
  },
  showLogs: false
});

export { FinanceChat as default };